var map = {
	"./AlchemyLab64.png": 100,
	"./AlchemyLabIcon.png": 101,
	"./Bank64.png": 102,
	"./BankIcon.png": 103,
	"./Cursor64.png": 104,
	"./CursorIcon.png": 105,
	"./Factory64.png": 106,
	"./FactoryIcon.png": 107,
	"./Farm64.png": 108,
	"./FarmIcon.png": 109,
	"./GrandmaIcon.png": 110,
	"./Mine64.png": 111,
	"./MineIcon.png": 112,
	"./Shipment64.png": 113,
	"./ShipmentIcon.png": 114,
	"./Temple64.png": 115,
	"./TempleIcon.png": 116,
	"./WizardTower64.png": 117,
	"./WizardTowerIcon.png": 118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;